import { Injectable } from "@angular/core";
import { PageModel } from "@app/shared/models/page.model";
import { Action, State, StateContext } from "@ngxs/store";
import { ClearPageContext, SetFilter, SetPageTab, SetSearchQuery } from "./page-context.action";


export interface PageContextStateModel {
  context: PageModel | null;
}

@State<PageContextStateModel>({
  name: 'pageContext',
  defaults: {
    context: null,
  },
})
@Injectable()
export class PageContextState {
  @Action(SetPageTab)
  setPageTab(ctx: StateContext<PageContextStateModel>, { payload }: SetPageTab): void {
    const state = ctx.getState();

    const updatedContext: PageModel = {
      ...(state.context ?? {} as PageModel),
      pageTab: payload,
    };

    ctx.patchState({ context: updatedContext });
  }

  @Action(SetFilter)
  setFilter(ctx: StateContext<PageContextStateModel>, { pageTab, payload }: SetFilter): void {
    const state = ctx.getState();

    const updatedContext: PageModel = {
      ...(state.context ?? {} as PageModel),
      filtersByTab: {
        ...state.context?.filtersByTab,
        [pageTab]: payload,
      },
    };

    ctx.patchState({ context: updatedContext });
  }

  @Action(SetSearchQuery)
  setSearchQuery(ctx: StateContext<PageContextStateModel>, { payload }: SetSearchQuery): void {
    const state = ctx.getState();

    const updatedContext: PageModel = {
      ...(state.context ?? {} as PageModel),
      searchQuery: payload,
    };

    ctx.patchState({ context: updatedContext });
  }

  @Action(ClearPageContext)
  clear(ctx: StateContext<PageContextStateModel>): void {
    ctx.setState({ context: null });
  }
}
